import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackBuyNowButtonPressed = () => useTrackConversion({ goal: KameleoonGoalData.BuyNowButtonPressed });
